<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    multiple?: boolean
  }>(),
  {
    multiple: () => false
  }
)

const emit = defineEmits<{
  (e: 'selected', files: FileList): void
}>()

async function fileDropped(event: DragEvent) {
  if (!event?.dataTransfer?.files || !event?.dataTransfer?.files?.length) {
    return
  }
  const files = event?.dataTransfer?.files
  fileSelected(files)
}

async function selectFileClicked() {
  const files = await openFileChooser()
  if (files) {
    fileSelected(files)
  }
}

function openFileChooser() {
  return new Promise<FileList | null>(resolve => {
    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = props.multiple
    input.onchange = () => resolve(input.files)
    input.click()
  })
}

function fileSelected(files: FileList) {
  emit('selected', files)
}
</script>

<template>
  <div class="file-upload-zone" @dragover.prevent @drop.prevent="fileDropped($event)">
    <button class="btn listing__btn" @click="selectFileClicked()">
      Select File
    </button>
  </div>
</template>

<style lang="scss" scoped>
.file-upload-zone {
  display: flex;
  align-content: center;
  justify-content: center;
  @include themify($themes) {
    border: 2px dashed themed('primaryColor');
    border-radius: rem-calc(4);
  }

  > * {
    flex: 1;
  }

  button {
    max-width: rem-calc(26);
    margin: rem-calc(26);
  }
}
</style>
